import { bootBoxTitles } from "./BootBoxConstants";

class BootBoxManager {
  static confirm(
    title: string,
    message: string,
    closeButton: boolean,
    callbackfun: [Function, any] | null = null,
    confirmButtonName: string = "Confirm"
  ) {
    window["bootbox"].confirm({
      title: title,
      message: `
            <div class="text-center "style="font-family: Noto Sans">
                 ${
                   !bootBoxTitles.includes(title)
                     ? "<p>Do you really want to delete?</p>"
                     : ""
                 }
                 <strong>${message}</strong>
                 ${
                   !bootBoxTitles.includes(title)
                     ? '<p><span style="background-color: #f2f2f2; display: inline-block; margin-top: 10px;">This cannot be undone</span></p>'
                     : ""
                 }
                 
          </div>`,
      centerVertical: true,
      size: "medium",
      closeButton: closeButton,

      buttons: {
        cancel: {
          label: "Cancel",
          className: "button-outlined mt-0 ps-3 pe-3 me-3 shadow-none",
        },
        confirm: {
          label: confirmButtonName,
          className: "button-fill shadow-none mt-0 ps-3 pe-3 ",
        },
      },
      callback: function (result: boolean) {
        if (result) {
          if (callbackfun !== null) {
            var args = callbackfun.slice(1);
            callbackfun[0](...args);
          }
        }
      },
    });
  }

  static simple_dialog(message: string, closeButton: boolean = false) {
    return window["bootbox"].dialog({
      message: message,
      closeButton: closeButton,
      centerVertical: true,
    });
  }

  static dialog(title: string, message: string, closeButton: boolean = false) {
    window["bootbox"].dialog({
      title: title,
      message: message,
      size: "medium",
      centerVertical: true,
      closeButton: closeButton,
      buttons: {
        ok: {
          label: "OK, I got it",
          className: "btn-info btn-sm",
          callback: function () {
            console.log("Custom OK clicked");
          },
        },
      },
    });
  }
  static rulesdialog(
    title: string,
    message: string,
    closeButton: boolean = false
  ) {
    window["bootbox"].dialog({
      title: title,
      message: message,
      size: "medium",
      centerVertical: true,
      closeButton: closeButton,
      buttons: {
        ok: {
          label: "OK, I got it",
          className: "btn-info btn-sm",
          callback: function () {
            console.log("Custom OK clicked");
          },
        },
      },
    });
  }
}

export default BootBoxManager;
